var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sms",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M38.309,10.008H27.234V3.691A3.7,3.7,0,0,0,23.543,0H3.691A3.7,3.7,0,0,0,0,3.691V38.309A3.7,3.7,0,0,0,3.691,42H23.543a3.7,3.7,0,0,0,3.691-3.691V31.435l4.2-4.2h6.873A3.7,3.7,0,0,0,42,23.543V13.7A3.7,3.7,0,0,0,38.309,10.008ZM2.461,3.691a1.232,1.232,0,0,1,1.23-1.23H23.543a1.232,1.232,0,0,1,1.23,1.23v1.23H2.461ZM24.773,38.309a1.232,1.232,0,0,1-1.23,1.23H3.691a1.232,1.232,0,0,1-1.23-1.23V34.617H24.773Zm0-6.152H2.461V7.383H24.773v2.625h-1.23A3.7,3.7,0,0,0,19.852,13.7v9.844a3.7,3.7,0,0,0,3.691,3.691h1.23Zm14.766-8.613a1.232,1.232,0,0,1-1.23,1.23H30.926a1.23,1.23,0,0,0-.87.36l-2.821,2.821V26h0A1.23,1.23,0,0,0,26,24.773H23.543a1.232,1.232,0,0,1-1.23-1.23V13.7a1.232,1.232,0,0,1,1.23-1.23H38.309a1.232,1.232,0,0,1,1.23,1.23Z",
    fill: "current"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(19.852 14.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M316.238,182H303.582a1.582,1.582,0,0,0,0,3.164h12.656a1.582,1.582,0,0,0,0-3.164Z",
    transform: "translate(-302 -182)",
    fill: "current"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(23.264 19.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M309.91,242h-6.328a1.582,1.582,0,0,0,0,3.164h6.328a1.582,1.582,0,0,0,0-3.164Z",
    transform: "translate(-302 -242)",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMessageIcon);
export default __webpack_public_path__ + "static/media/PhoneMessageIcon.64cfb840.svg";
export { ForwardRef as ReactComponent };